import { PEBarData, PEData, PEDonutData, PEPieData } from "@components/chart/types";
import WorkLoadComponent from "@components/workload_component/WorkLoadComponent";
import { MetricService } from "app/services/metric/MetricService";
import { getMetricColors } from "app/utils/utils";
import React, { useEffect, useState } from "react";
import { ProgrammeExplorerFilterParams } from "../ProgrammeExplorerProvider";
import ProgrammeExplorerHorizontalBarChart from "./ProgrammeExplorerHorizontalBarChart";

interface Props {
  filters: ProgrammeExplorerFilterParams,
  metric: string
}

export const ProgrammeExplorerFilteredCardTop10TherapeuticAreas: React.FC<Props> = ({ filters, metric }) => {

  const [series, setSeries] = useState<PEBarData[] | null>(null)
  const mainAbortController = new AbortController()


  useEffect(() => {

    setSeries(null)

    getMetrics(mainAbortController.signal)

    return () => {
      mainAbortController.abort()
    }

  }, [filters])


  const getMetrics = async (signal: AbortSignal) => {
    const response = await getTop10TherapeuticAreaMetric(signal)
    setSeries(response)
  }


  const getTop10TherapeuticAreaMetric = async (signal: AbortSignal): Promise<PEBarData[] | null> => {

    const modifiedFilters: any = {
      ...filters,
      filter_filters: {
        ...filters.filter_filters,
        programmes: [],
        therapeutic_areas: [],
        campaigns: [],
        group: "therapeutic_area",
        source: filters.filter_filters.source || undefined
      }
    }

    const response = (await (new MetricService()).getMetricEndpointData(modifiedFilters, metric, 'group', signal)).getResponseData()

    if (response === undefined || !response.success) return null

    let barData: PEPieData[] = response.data.map((item: any, index: number) => {
      return {
        name: item.group,
        color: getMetricColors(1),
        data: item.total,
      }
    })

    return barData

  }

  return (
    <WorkLoadComponent evaluateElement={series}>

      <ProgrammeExplorerHorizontalBarChart data={series || []} position={'left'} ></ProgrammeExplorerHorizontalBarChart>

    </WorkLoadComponent>
  )
}